import { useMutation } from "react-query";
import { queryClient } from "services/queries";
import { postEditProfile } from "../requests/Profile";

export function useMutationEditProfile() {
    const query = useMutation(postEditProfile, {
        onSuccess: (data) => {
            if(data?.success) {
                queryClient.invalidateQueries('loginInfo')
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
